"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import SideNav from "@/components/teacher/SideNav"
import { useAuth } from "@/lib/auth"

export default function TeacherLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const { user, token, loading } = useAuth()
  const isLoginPage = pathname.startsWith("/teacher/login")

  useEffect(() => {
    if (loading || isLoginPage) return
    if (!token || user?.role !== "teacher") {
      window.location.assign("/teacher/login")
    }
  }, [loading, token, user?.role, isLoginPage])

  if (isLoginPage) {
    return <main className="min-h-screen">{children}</main>
  }

  if (loading || !token || user?.role !== "teacher") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <p className="text-text-muted">載入中...</p>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen bg-bg">
      <SideNav />
      <main className="flex-1 overflow-auto">
        {children}
      </main>
    </div>
  )
}
